import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import history from '~/services/history';
import api from '~/services/api';

import { saveLi1Failure, saveLi1Success, updateLi1Failure, updateLi1Success } from './actions';

export function* saveLi1({ payload }) {
  try {
    yield call(api.post, 'api/li1', payload.data, { withCredentials: true });

    yield put(saveLi1Success());

    toast.success('LI1 criado com sucesso!')

    history.push('/specifications/pilar3/resources/li1');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(saveLi1Failure());
  }
}

export function* updateLi1({ payload }) {
  try {
    const { id } = payload.data;
    yield call(api.post, `api/li1/${id}`, payload.data, { withCredentials: true });

    yield put(updateLi1Success());

    toast.success('LI1 atualizado com sucesso!')

    history.push('/specifications/pilar3/resources/li1');
  } catch (error) {
    if (error?.response?.data?.message) {
      toast.error(error.response.data.message);
    } else if (error?.message) {
      toast.error(error.message);
    } else {
      toast.error('Ocorreu um erro inesperado. Tente novamente.');
    }
    yield put(updateLi1Failure());
  }
}

export default all([
  takeLatest('@li1/SAVE_REQUEST', saveLi1),
  takeLatest('@li1/UPDATE_REQUEST', updateLi1)
]);